import {Row, Col} from '@/grid';
import Container from '@/container';
import {H3, PNoMargin} from '@/typography';
import Link from '@/links';
import {withBgPartnerApplication} from '@/hocs/withColors';
import {withMarginBottomZeroToMd} from '@/hocs/withSpacing';
import {withFlexHolder} from '@/hocs/withFlex';
import styles from './styles.module.scss';

const BgDiv = withBgPartnerApplication('div');
const FlexCenter = withFlexHolder(BgDiv);
const MarginedP = withMarginBottomZeroToMd(PNoMargin);

const SubmitPartnerApplication = () => (
  <FlexCenter>
    <Container>
      <div className={styles.banner}>
        <Row center="xs" start="lg" around="lg" middle="lg">
          <Col xs={12} lg={6}>
            <H3>Apply to become a Workable partner</H3>
            <MarginedP>
              Want more API access, or to become an official Workable partner? Tell us about
              yourself and your product.
            </MarginedP>
          </Col>
          <Col xs={12} lg={4}>
            <Link href="/partnership-program/apply" variant="primary-no-arrow">
              Submit partner application
            </Link>
          </Col>
        </Row>
      </div>
    </Container>
  </FlexCenter>
);

export default SubmitPartnerApplication;
